"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _SwitchBase = _interopRequireDefault(require("@mui/material/internal/SwitchBase"));
var _Check = _interopRequireDefault(require("@mui/icons-material/Check"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
var _helpers = require("../utils/helpers");
var _withStyles = _interopRequireDefault(require("@mui/styles/withStyles"));
var styles = exports.styles = function styles(theme) {
  return {
    root: {
      display: 'inline-flex',
      width: 62,
      position: 'relative',
      flexShrink: 0,
      zIndex: 0
    },
    bar: {
      borderRadius: 7,
      display: 'block',
      position: 'absolute',
      width: 34,
      height: 14,
      top: '50%',
      marginTop: -7,
      left: '50%',
      marginLeft: -17,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.mode === 'light' ? theme.palette.neutral.main : '#fff',
      opacity: theme.palette.mode === 'light' ? 0.38 : 0.3
    },
    icon: {
      boxShadow: theme.shadows[1],
      width: 20,
      height: 20,
      borderRadius: '50%',
      backgroundColor: theme.palette.background2,
      color: theme.palette.background2,
      padding: 2
    },
    iconDisabled: {
      backgroundColor: theme.palette.mode === 'light' ? '#bdbdbd' : '#424242',
      color: theme.palette.mode === 'light' ? '#fafafa' : '#bdbdbd',
      '&:not($iconChecked)': {
        color: theme.palette.mode === 'light' ? '#bdbdbd' : '#424242'
      }
    },
    // For SwitchBase
    switchBaseRoot: {
      zIndex: 1,
      color: theme.palette.mode === 'light' ? '#fafafa' : '#bdbdbd',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      height: 40,
      width: 40
    },
    disabled: {
      color: theme.palette.mode === 'light' ? '#bdbdbd' : '#424242',
      '& + $bar': {
        backgroundColor: theme.palette.mode === 'light' ? '#000' : '#fff',
        opacity: theme.palette.mode === 'light' ? 0.12 : 0.1
      }
    },
    iconNotChecked: {
      color: "#CBCBCB"
    },
    iconChecked: {},
    iconCheckedPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },
    iconCheckedSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },
    iconCheckedPositive: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.contrastText
    },
    iconCheckedNegative: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },
    iconCheckedMiddle: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.warning.contrastText
    },
    iconCheckedNeutral: {
      backgroundColor: theme.palette.neutral.main,
      color: theme.palette.neutral.contrastText
    },
    checkedPrimary: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.5
      }
    },
    checkedSecondary: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.5
      }
    },
    checkedPositive: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.success.main,
        opacity: 0.5
      }
    },
    checkedNegative: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.error.main,
        opacity: 0.5
      }
    },
    checkedMiddle: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.warning.main,
        opacity: 0.5
      }
    },
    checkedNeutral: {
      transform: 'translateX(18px)',
      '& + $bar': {
        backgroundColor: theme.palette.neutral.main,
        opacity: 0.5
      }
    }
  };
};
function HiSwitch(props) {
  var classes = props.classes,
    className = props.className,
    checked = props.checked,
    color = props.color,
    disabled = props.disabled,
    other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "checked", "color", "disabled"]);
  var isHiColor = ['primary', 'secondary', 'success', 'error', 'warning', 'neutral'].includes(color);
  var iconClass = (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.iconNotChecked, !checked), classes.iconChecked, checked), classes.iconCheckedNeutral, !disabled && checked && !isHiColor), classes["iconChecked".concat((0, _helpers.capitalize)(color))], !disabled && checked && isHiColor), classes.iconDisabled, disabled));
  var icon = /*#__PURE__*/_react.default.createElement(_Close.default, {
    className: iconClass
  });
  var checkedIcon = /*#__PURE__*/_react.default.createElement(_Check.default, {
    className: iconClass
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_SwitchBase.default, (0, _extends2.default)({
    type: "checkbox",
    icon: icon,
    classes: {
      root: classes.switchBaseRoot,
      checked: isHiColor && !disabled ? classes["checked".concat((0, _helpers.capitalize)(color))] : classes.checkedNeutral,
      disabled: classes.disabled
    },
    checkedIcon: checkedIcon,
    checked: checked,
    disabled: disabled,
    inputProps: {
      value: checked ? "on" : "off"
    }
  }, other)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.bar
  }));
}
HiSwitch.defaultProps = {
  color: 'inherit'
};
var _default = exports.default = (0, _withStyles.default)(styles, {
  hiComponent: true,
  name: 'HmuiHiSwitch'
})(HiSwitch);